import { reactive } from 'vue'
import breakpoints from '@assets/scss/modules/breakpoints.module.scss'

/**
 * @typedef {keyof typeof breakpoints} BreakpointKey
 */

/**
 * @typedef {Record<BreakpointKey, boolean>} BreakpointStatus
 */

/**
 * @type {BreakpointKey[]}
 */
const breakpointKeys = Object.keys(breakpoints)
// eslint-disable-next-line no-use-before-define
const breakpointStatus = reactive(createBreakpointStatus(breakpointKeys))

function createMediaQuery(breakpointValue) {
  const breakpoint = parseInt(breakpointValue, 10) - 0.02

  return window.matchMedia(`(max-width: ${breakpoint}px)`)
}

/**
 *
 * @param {BreakpointKey[]} keys
 */
function createBreakpointStatus(keys) {
  return keys.reduce((acc, key) => {
    acc[key] = false
    return acc
  }, {})
}

/**
 *
 * @param {BreakpointKey} key
 * @param {MediaQueryList, MediaQueryListEvent} mql
 */
function updateBreakpointStatus(key, mql) {
  if (breakpointStatus[key] === mql.matches) return

  breakpointStatus[key] = mql.matches
}

function createMediaQueryListener() {
  breakpointKeys.forEach(key => {
    const mql = createMediaQuery(breakpoints[key])

    updateBreakpointStatus(key, mql)

    mql.onchange = e => updateBreakpointStatus(key, e)
  })
}

/**
 * Для получения значения синхронно (если реактивность является проблемой)
 * @param {BreakpointKey} key
 * @returns {boolean}
 */
function getSync(key) {
  return createMediaQuery(breakpoints[key]).matches
}

createMediaQueryListener()

export default function useAdaptive() {
  return {
    is: breakpointStatus,
    getSync,
  }
}
